"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.primerInitCheckout = void 0;
var checkout_web_1 = require("@primer-io/checkout-web");
var type_1 = require("../type");
var paymentMethodType = '';
var primerInitCheckout = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var currentPaymentId, checkout, checkoutPrimerResponse;
    var primerClientToken = _b.primerClientToken, checkoutOptions = _b.checkoutOptions, api = _b.api, orderId = _b.orderId, onErrorCustom = _b.onErrorCustom;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                currentPaymentId = '';
                checkout = checkout_web_1.Primer.showUniversalCheckout(primerClientToken, __assign(__assign({}, checkoutOptions), { container: '#primer-checkout-container', paymentHandling: 'MANUAL', vault: { visible: false }, onTokenizeSuccess: function (paymentMethodTokenData, handler) { return __awaiter(void 0, void 0, void 0, function () {
                        var updatedOrderId, data, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    updatedOrderId = sessionStorage.getItem('updatedOrderId');
                                    data = {
                                        integrationType: type_1.IntegrationTypeEnum.Primer,
                                        paymentToken: paymentMethodTokenData.token,
                                        orderId: updatedOrderId ? updatedOrderId : orderId,
                                        paymentMethodType: paymentMethodTokenData.paymentInstrumentType,
                                    };
                                    paymentMethodType = paymentMethodTokenData.paymentInstrumentType;
                                    checkoutOptions.onBeforePaymentCreate(data, handler);
                                    return [4 /*yield*/, api.createPayment(data)];
                                case 1:
                                    response = _a.sent();
                                    if (response.status === type_1.PaymentStatus.error ||
                                        response.checkoutState === type_1.CheckoutStateEnum.failed) {
                                        onErrorCustom('create payment failed', 'The payment failed. Please try with another payment method');
                                        checkoutOptions.onCheckoutFail('create payment failed', data);
                                        return [2 /*return*/, handler.handleFailure('The payment failed. Please try with another payment method.')];
                                    }
                                    else if (response.checkoutState === type_1.CheckoutStateEnum.completed) {
                                        checkoutOptions.onCheckoutComplete(data);
                                    }
                                    currentPaymentId = response.integrationPaymentId;
                                    // If a new clientToken is available, call `handler.continueWithNewClientToken` to refresh the client session.
                                    // The checkout will automatically perform the action required by the Workflow.
                                    if (response.requiredAction) {
                                        return [2 /*return*/, handler.continueWithNewClientToken(response.requiredAction.clientToken)];
                                    }
                                    // Display the success screen
                                    return [2 /*return*/, handler.handleSuccess()];
                            }
                        });
                    }); }, onResumeSuccess: function (resumeTokenData, handler) { return __awaiter(void 0, void 0, void 0, function () {
                        var updatedOrderId, data, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    updatedOrderId = sessionStorage.getItem('updatedOrderId');
                                    data = {
                                        integrationType: type_1.IntegrationTypeEnum.Primer,
                                        paymentToken: resumeTokenData.resumeToken,
                                        orderId: updatedOrderId ? updatedOrderId : orderId,
                                        integrationPaymentId: currentPaymentId,
                                    };
                                    return [4 /*yield*/, api.resumePayment(data)];
                                case 1:
                                    response = _a.sent();
                                    // Call `handler.handleFailure` to cancel the flow and display an error message
                                    if (response.status === type_1.PaymentStatus.error ||
                                        response.checkoutState === type_1.CheckoutStateEnum.failed) {
                                        onErrorCustom('resume payment failed', 'The payment failed. Please try with another payment method');
                                        return [2 /*return*/, handler.handleFailure('The payment failed. Please try with another payment method.')];
                                    }
                                    else if (response.checkoutState === type_1.CheckoutStateEnum.completed) {
                                        checkoutOptions.onCheckoutComplete({
                                            paymentMethodType: paymentMethodType,
                                        });
                                    }
                                    // If a new clientToken is available, call `handler.continueWithNewClientToken`
                                    // to refresh the client session.
                                    // The checkout will automatically perform the action required by the Workflow
                                    if (response.requiredAction) {
                                        return [2 /*return*/, handler.continueWithNewClientToken(response.requiredAction.clientToken)];
                                    }
                                    // Display the success screen
                                    return [2 /*return*/, handler.handleSuccess()];
                            }
                        });
                    }); } }));
                return [4 /*yield*/, checkout];
            case 1:
                checkoutPrimerResponse = _c.sent();
                return [2 /*return*/, checkoutPrimerResponse];
        }
    });
}); };
exports.primerInitCheckout = primerInitCheckout;
//# sourceMappingURL=index.js.map